import BreadCrumb from '../../components/breadCrumb';
import CustomFilterSelect from '../../shared/customFilterSelect';
import './style.scss';
import ItemsDescription from '../../components/assitenceAdmin/itemsDescription';
import {
  getAllAttendances,
  getAttendances,
  getSchools
} from '../../API/apiService';
import { useEffect, useState } from 'react';
import DownloadAttendances from '../../components/downloadAttendances';
import { useLoader } from '../../contexts/loader/loader';

function Assistence() {
  // STATES //
  const [loadComplete, setLoadComplete] = useState(false);
  const [disabledButton, setDisabledButton] = useState(false);

  const [meetingGroups, setMeetingGroups] = useState(null);

  const [schoolsList, setSchoolsList] = useState([]);
  const [groupsList, setGroupsList] = useState([]);

  const [attendances, setAttendances] = useState(null);
  const [schools, setSchools] = useState([]);
  const [selectedSchool, setSelectedSchool] = useState(null);
  const { show } = useLoader();

  async function loadAttendances() {
    const a = await getAllAttendances();
    if (a) {
      setAttendances(a);
      setLoadComplete(true);
      setDisabledButton(false);
      await show(false);
    }
  }

  function onSelectedFilter(name, id, value) {
    const selected = schools.find(s => Number(s.id) === Number(id));
    if (selected) {
      setSelectedSchool(selected);
      setGroupsList(
        selected.groups.map(s => {
          return {
            id: s.id,
            name: s.code
          };
        })
      );
    }
  }

  async function onSelectedGroup(name, id, value) {
    const attendancesByGroup = await getAttendances(selectedSchool.id, id);
    const uniqueMeetingGroupIds = [
      ...new Set(
        attendancesByGroup.attendancesModel.map(obj => obj.meeting_group_id)
      )
    ];
    const mg = uniqueMeetingGroupIds.map(id => {
      const attendanceM = attendancesByGroup.attendancesModel.find(
        a => a.meeting_group_id === id
      );
      if (attendanceM) {
        return attendanceM.meetingGroup;
      }
      return null;
    });

    mg.forEach(m => {
      const meetingName = m?.type === 'MEETING' ? 'Encuentro' : 'Evento';
      m.meetingName = `${meetingName} ${m?.order}`;
      m.groupName = value;
    });

    setMeetingGroups({ school: selectedSchool, meetingGroups: mg });
  }

  async function getSchoolsInfo() {
    const info = await getSchools();
    if (info) {
      setSchools(info);
      setSchoolsList(
        info.map(s => {
          return {
            id: s.id,
            name: s.code
          };
        })
      );
    }
  }

  async function generateReport() {
    setDisabledButton(true);
    await show(true);
    await loadAttendances();
  }

  useEffect(() => {
    getSchoolsInfo();
  }, []);
  return (
    <>
      <section className='assistence-main-container'>
        <BreadCrumb />
        <div className='filters-container'>
          {loadComplete && <DownloadAttendances attendances={attendances} />}
          <div className='filters-top'>
            <p className='title'>FILTROS DE BÚSQUEDA DE ASISTENCIA</p>
          </div>
          <div className='filters-content'>
            <CustomFilterSelect
              optionsList={schoolsList}
              placeholder={'Código de escuela'}
              addInfo={onSelectedFilter}
            />
            <CustomFilterSelect
              optionsList={groupsList}
              placeholder={'Grupo'}
              addInfo={onSelectedGroup}
            />
          </div>
        </div>
        {!loadComplete && (
          <div className='button-container'>
            <button
              onClick={generateReport}
              disabled={disabledButton}
              title={'Generar Reporte Asistencias'}>
              Generar Reporte
            </button>
          </div>
        )}
        <div className='meetings-main-container'>
          <div className='meeting-top'>
            <p className='title'>ENCUENTROS</p>
            <p className='paginator-text'>
              <span></span> <span></span>
            </p>
          </div>

          {meetingGroups && (
            <div className='info-meetings-content'>
              <ItemsDescription meetingGroups={meetingGroups} />
            </div>
          )}
        </div>
      </section>
    </>
  );
}

export default Assistence;
